import React,{useEffect} from 'react';
import Header from '../../components/Header';
import JobApplyMain from './ApplyMain';
import Footer from '../../components/Footer';


const JobApply = () => {
        useEffect(() => {
        document.title = "Jobs Application | Society of Aquaculture Professionals";
      }, []);
  return (
    <>
      <Header/>

      <JobApplyMain />

      <Footer/>
    </>
  );
};

export default JobApply;
